__turbopack_context__.v({
  "daysInAdvance": "ReminderStyles-module-scss-module__R9-7Ma__daysInAdvance",
  "descriptionParagraph": "ReminderStyles-module-scss-module__R9-7Ma__descriptionParagraph",
  "dividerStyling": "ReminderStyles-module-scss-module__R9-7Ma__dividerStyling",
  "formInputColumn": "ReminderStyles-module-scss-module__R9-7Ma__formInputColumn",
  "increaseSize": "ReminderStyles-module-scss-module__R9-7Ma__increaseSize",
  "largeReminderDropdownContainer": "ReminderStyles-module-scss-module__R9-7Ma__largeReminderDropdownContainer",
  "reminderDropdownContainer": "ReminderStyles-module-scss-module__R9-7Ma__reminderDropdownContainer",
  "reminderInfoButton": "ReminderStyles-module-scss-module__R9-7Ma__reminderInfoButton",
  "reminderInput": "ReminderStyles-module-scss-module__R9-7Ma__reminderInput",
  "removeReminderButton": "ReminderStyles-module-scss-module__R9-7Ma__removeReminderButton",
  "secondRow": "ReminderStyles-module-scss-module__R9-7Ma__secondRow",
});
